import React, { ReactElement } from 'react';

import useDiscardChangesModalContainer from 'adapter/in/dashboards/containers/Modals/DiscardChangesModal/useDiscardChangesModal';
import ConfirmChangesModal from 'adapter/in/common/components/ConfirmActionModal/ConfirmActionModal';
import i18n from 'asset/translation';

import gtmIds from 'adapter/in/dashboards/config/gtm';

const gtm = gtmIds.dashboard.confirmChangesModal.actions;

const EditDashboardPageDiscardChangesModalContainer = (): ReactElement => {
    const { onModalAbortChanges, onModalCancel, modalDiscardChanges, onModalSaveAndProceed } = useDiscardChangesModalContainer();
    return (
        <ConfirmChangesModal
            onSaveAndProceed={onModalSaveAndProceed}
            onProceed={onModalAbortChanges}
            onClose={onModalCancel}
            isOpen={modalDiscardChanges.show}
            message={i18n.t('dashboards.edit.discardChangesModalText')}
            proceedButtonText={i18n.t('dashboards.edit.discardChangesModalDiscard')}
            title={i18n.t('dashboards.edit.discardChangesModalTitle')}
            saveAndProceedButtonText={i18n.t('dashboards.edit.discardChangesModalSaveAndProceed')}
            proceedButtonVariant='destructive'
            dataIdContext={gtm}
        />
    );
};

export default EditDashboardPageDiscardChangesModalContainer;
